import { Icon, IconButton } from "@jkast90/kast-common/ui";

interface ExpandCollapseButtonsProps {
  onExpandAll: () => void;
  onCollapseAll: () => void;
  expandTitle?: string;
  collapseTitle?: string;
}

/** Expand-all and collapse-all, as small primary icon buttons. */
export default function ExpandCollapseButtons({
  onExpandAll,
  onCollapseAll,
  expandTitle = "Expand all",
  collapseTitle = "Collapse all",
}: ExpandCollapseButtonsProps) {
  return (
    <>
      <IconButton
        label={expandTitle}
        variant="primary"
        size="sm"
        onClick={onExpandAll}
      >
        <Icon name="expand_more" size={18} />
      </IconButton>
      <IconButton
        label={collapseTitle}
        variant="primary"
        size="sm"
        onClick={onCollapseAll}
      >
        <Icon name="expand_less" size={18} />
      </IconButton>
    </>
  );
}
